import {
  Autocomplete,
  Box,
  colors,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import DropZone from "components/Dropzone_one";
import { useEffect, useState } from "react";
import nationalities from "data/nationalities_th.json";
import { PrefixOptions } from "contants/options";
import WatermarkedImage from "components/Pawn/WatermarkImage";

const fields = [
  {
    label: "คำนำหน้า",
    name: "prefix",
    type: "autocomplete",
    required: true,
    options: PrefixOptions,
    defaultValue: "นาย",
  },
  { label: "ชื่อ-นามสกุล", name: "fullName", type: "text", required: true },
  {
    label: "เลขบัตรประชาชน/ Passport No.",
    name: "idCardNumber",
    type: "text",
    required: true,
    inputProps: {
      maxLength: 20,
      minLength: 6,
      inputMode: "text",
      pattern: "[A-Za-z0-9]*",
    },
  },
  {
    label: "เบอร์โทรศัพท์",
    name: "phoneNumber",
    type: "text",
    required: true,
    inputProps: {
      minLength: 9,
      maxLength: 10,
      inputMode: "numeric",
      pattern: "[0-9]*",
    },
  },
  { label: "ที่อยู่", name: "address", type: "text", required: true },
  {
    label: "สัญชาติ",
    name: "nationality",
    type: "autocomplete",
    required: true,
    options: nationalities,
    defaultValue: "ไทย",
  },
];

const RenderFieldsCustomers = ({
  sx,
  formik,
  setCustomerImage,
  images = [],
  ...props
}) => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const [isManualUpload, setIsManualUpload] = useState(false);

  // useEffect(() => {
  //   if (images && images.length > 0) {
  //     // ล้างเฉพาะ UI DropZone แต่ไม่ trigger setCustomerImage([])
  //     if (files.length > 0) {
  //       setFiles([]);
  //     }
  //   }
  // }, [images]);

  useEffect(() => {
    if (images && images.length > 0) {
      const first = images[0];
      const isBase64 =
        typeof first === "string" && first.startsWith("data:image");
      const isBase64Url =
        typeof first?.url === "string" && first.url.startsWith("data:image");
      if (isBase64 || isBase64Url) {
        console.log("🪪 Detected ID card image, resetting manual flag");
        setIsManualUpload(false);
        setFiles([]);
      }
    }
  }, [images]);

  useEffect(() => {
    if (images && images.length > 0) {
      const first = images[0];
      if (
        first?.url?.startsWith?.("data:image") ||
        (typeof first === "string" && first.startsWith("data:image"))
      ) {
        if (isManualUpload) {
          console.log("⚡ Immediate flag reset for ID card image");
          setIsManualUpload(false);
        }
      }
    }
  }, [images, isManualUpload]);

  const handleDeleteFile = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
    // formik.setFieldValue("customerImage", newFiles);
    console.log("x1");
    setCustomerImage(newFiles);
    if (newFiles.length === 0) {
      setError(null);
    }
  };

  useEffect(() => {
    if (files.length > 0) {
      console.log("x2");
      setCustomerImage(files.map((file) => file.file));
    }
    // else {
    //   // setCustomerImage([]);
    //   if (!images || images.length === 0) {
    //     setCustomerImage([]);
    //   }
    // }
  }, [files]);

  return (
    <Box sx={{ ...sx }}>
      <Typography variant="h5" sx={{ mb: 1 }}>
        ข้อมูลลูกค้า
      </Typography>
      <Box
        sx={{
          p: 2,
          backgroundColor: "white",
          borderRadius: 2,
          border: `1px solid ${colors.grey[300]}`,
        }}
      >
        <Grid container>
          <Grid item xs={7}>
            {fields.map((field, index) => (
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  m: 1,
                }}
                key={index}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "baseline",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      width: "200px",
                      lineHeight: "20px",
                    }}
                  >
                    {field.label}
                    {field.required && <span style={{ color: "red" }}>*</span>}
                  </Typography>
                  {field.type === "autocomplete" ? (
                    field.name === "nationality" ? (
                      <Autocomplete
                        {...props}
                        disablePortal
                        disableClearable
                        options={field.options || []}
                        getOptionLabel={(option) => option.nationality}
                        value={
                          nationalities.find(
                            (n) => n.nationality === formik.values[field.name]
                          ) ||
                          nationalities.find(
                            (n) => n.nationality === field.defaultValue
                          )
                        }
                        onChange={(event, newValue) => {
                          formik.setFieldValue(
                            field.name,
                            newValue.nationality
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder={field.placeholder}
                            required={field.required}
                            error={
                              formik.touched[field.name] &&
                              Boolean(formik.errors[field.name])
                            }
                            helperText={
                              formik.touched[field.name] &&
                              formik.errors[field.name]
                                ? formik.errors[field.name]
                                : ""
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                bgcolor: "white",
                                height: "40px",
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        fullWidth
                      />
                    ) : (
                      <Autocomplete
                        {...props}
                        disablePortal
                        options={field.options || []}
                        value={formik.values[field.name] || null}
                        onChange={(event, newValue) => {
                          formik.setFieldValue(field.name, newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder={field.placeholder}
                            required={field.required}
                            error={
                              formik.touched[field.name] &&
                              Boolean(formik.errors[field.name])
                            }
                            helperText={
                              formik.touched[field.name] &&
                              formik.errors[field.name]
                                ? formik.errors[field.name]
                                : ""
                            }
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                bgcolor: "white",
                                height: "40px",
                              },
                            }}
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        fullWidth
                      />
                    )
                  ) : (
                    <TextField
                      {...props}
                      fullWidth
                      type={field.type}
                      variant="outlined"
                      name={field.name}
                      placeholder={field.placeholder}
                      required={field.required}
                      value={formik.values[field.name] || ""}
                      error={
                        formik.touched[field.name] &&
                        Boolean(formik.errors[field.name])
                      }
                      helperText={
                        formik.touched[field.name] && formik.errors[field.name]
                          ? formik.errors[field.name]
                          : ""
                      }
                      onBlur={formik.handleBlur}
                      onChange={(e) => {
                        // Update the data state with the new value
                        formik.setFieldValue(field.name, e.target.value);
                      }}
                      onKeyPress={
                        field.inputProps &&
                        field.inputProps.inputMode === "numeric"
                          ? (e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }
                          : null
                      }
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          bgcolor: "white",
                          height: "40px",
                        },
                      }}
                      inputProps={field.inputProps || {}}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                </Box>
              </Grid>
            ))}
          </Grid>
          <Grid item xs={5} sx={{ mt: 1 }}>
            {/* DropZone */}
            {/* <DropZone
              files={files}
              setFiles={(newFiles) => {
                // setFiles(newFiles);
                // if (newFiles.length > 0) {
                //   setCustomerImage(newFiles.map((f) => f.file));
                // }
                // ตรวจสอบก่อนว่าค่าเป็น array หรือไม่
                // const normalizedFiles = Array.isArray(newFiles) ? newFiles : [newFiles];
                // setFiles(normalizedFiles);

                // if (normalizedFiles.length > 0) {
                //   setCustomerImage(normalizedFiles.map((f) => f.file));
                // }
              }}
              setError={setError}
              maxFiles={1}
              onDelete={(index) => handleDeleteFile(index)}
            /> */}
            {!props.disabled ? (
              <>
                {error && (
                  <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                    {error}
                  </Typography>
                )}
                <DropZone
                  files={files}
                  setFiles={(newFiles) => {
                    setFiles(newFiles);
                    setIsManualUpload(true);
                    // formik.setFieldValue("customerImage", newFiles);
                  }}
                  setError={setError}
                  maxFiles={1}
                  onDelete={(index) => handleDeleteFile(index)}
                />
                {/* ถ้ามีภาพ (จากบัตรหรือจาก DropZone) */}
                {!isManualUpload && images && images.length > 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mt: 1,
                      p: 1,
                      border: `1px solid ${colors.grey[300]}`,
                      borderRadius: 1.5,
                      backgroundColor: "#fff",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <img
                        src={images[0]?.url || images[0]}
                        alt="customer"
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: 4,
                          objectFit: "cover",
                        }}
                      />
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {images[0]?.name || "id_card_photo.jpg"}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ fontSize: "0.75rem" }}
                        >
                          Complete
                        </Typography>
                      </Box>
                    </Box>

                    <Typography
                      variant="body2"
                      color="error"
                      sx={{
                        cursor: "pointer",
                        "&:hover": { textDecoration: "underline" },
                      }}
                      onClick={() => {
                        setCustomerImage([]);
                        setFiles([]);
                        setIsManualUpload(false);
                      }}
                    >
                      X
                    </Typography>
                  </Box>
                )}
              </>
            ) : images && images.length > 0 ? (
              <WatermarkedImage
                src={images[0]?.url || images[0]} // รองรับทั้ง object และ string
                alt="customer"
              />
            ) : (
              <Box
                sx={{
                  width: 200,
                  height: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#F8F7FD",
                  color: "#B0B0B0",
                }}
              >
                ไม่มีรูปภาพ
              </Box>
            )}

            {/* {images && images.length > 0 ? (
              <Box sx={{ padding: 1, width: "100%", height: "214px" }}>
                <img
                  src={images[0]?.url || images[0]} // รองรับทั้ง object และ string
                  alt="customer"
                  style={{
                    borderRadius: 2,
                    width: "100%",
                    height: "100%",
                    // objectFit: "cover",
                  }}
                />
              </Box>
              ) : (
                <>
                {error && (
                  <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                    {error}
                  </Typography>
                )}
                  <DropZone
                    files={files}
                    setFiles={(newFiles) => {
                      setFiles(newFiles);
                    }}
                    setError={setError}
                    maxFiles={1}
                    onDelete={(index) => handleDeleteFile(index)}
                  />
                </>
            )} */}
            {/* {props.disabled && images ? (
              <Box sx={{ padding: 1, width: "100%", height: "214px" }}>
                {images.length > 0 ? (
                  <img
                    src={images[0].url}
                    alt="customer"
                    style={{
                      borderRadius: 2,
                      width: "100%",
                      height: "100%",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#F8F7FD",
                      color: "#B0B0B0",
                    }}
                  >
                    ไม่มีรูปภาพ
                  </Box>
                )}
              </Box>
            ) : (
              <>
                {error && (
                  <Typography variant="body2" color="error" sx={{ mb: 1 }}>
                    {error}
                  </Typography>
                )}
                <DropZone
                  files={files}
                  setFiles={(newFiles) => {
                    setFiles(newFiles);
                    // formik.setFieldValue("customerImage", newFiles);
                  }}
                  setError={setError}
                  maxFiles={1}
                  onDelete={(index) => handleDeleteFile(index)}
                />
              </>
            )} */}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default RenderFieldsCustomers;
